import { ParsedPartner } from "@justhome/common";
import { PartnerProvider } from "@lib/context/partner/context";
import Head from "next/head";
import { FC, PropsWithChildren } from "react";

interface CobrandedProps {
  partner: ParsedPartner;
}

export const Cobranded: FC<PropsWithChildren<CobrandedProps>> = ({
  partner,
  children,
}) => {
  const initialState = {
    partner,
  };
  return (
    <>
      <Head>
        <style>{partner.themeCss}</style>
      </Head>
      <PartnerProvider initialState={initialState}>{children}</PartnerProvider>
    </>
  );
};
